export const breakpoints = {
  from360: "screen and (min-width: 360px)",
  to360: "screen and (max-width: 359px)",
  fromTny: "screen and (min-width: 400px)",
  toTny: "screen and (max-width: 399px)",
  fromSml: "screen and (min-width: 480px)",
  toSml: "screen and (max-width: 479px)",
  from520: "screen and (min-width: 520px)",
  to520: "screen and (max-width: 520px)",
  fromMed: "screen and (min-width: 768px)",
  toMed: "screen and (max-width: 767px)",
  fromLrg: "screen and (min-width: 992px)",
  toLrg: "screen and (max-width: 991px)",
  fromXLrg: "screen and (min-width: 1200px)",
  toXlrg: "screen and (max-width: 1199px)",
  fromHuge: "screen and (min-width: 1440px)",
  toHuge: "screen and (max-width: 1439px)",
  from1800: "screen and (min-width: 1800px)",
  to1800: "screen and (max-width: 1799px)",
  fromXHuge: "screen and (min-width: 2000px)",
  toXHuge: "screen and (max-width: 1999px)",
};
